import React from 'react';

import { ApolloProvider } from '@apollo/client';

import { SnackbarProvider } from '@clutter/clean';

import { client } from '@portal/libraries/apollo';

export const Config: React.FC = ({ children }) => (
  <ApolloProvider client={client}>
    <SnackbarProvider>{children}</SnackbarProvider>
  </ApolloProvider>
);
